import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';
import { Box, Dialog, DialogContent } from '@mui/material';
import { Fullscreen, Close } from '@mui/icons-material';
import { Colors } from '../../constants/colors';
import vaultImageProxy from '../Shared/vaultImageProxy';
import { VaultButton } from '../Shared';
import { getRotation } from '../../utils/photoRotation';

const height = '56.25%';

const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: ${Colors.BLACK_100};
  padding-bottom: ${height};
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const FSImageWrapper = styled.div`
  margin: 5px;
  justify-content: center;
  display: 'flex';
  alignItems: 'center'
`;

const imageStyle = `
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

const fullSizeImageStyle = `
width: 100%;
height: auto;
`;

const PreviewImage = (url, photoRotation) => {
  const computedRotation = getRotation(photoRotation);
  if (computedRotation) {
    const Image = vaultImageProxy(
      styled.img`
        object-fit:contain;
        ${`transform: rotate(${computedRotation.rotation}deg)`};
        ${computedRotation.imageFlipped ? `width:${height}` : 'height: 100%;'};
      `,
    );
    return <Image id="AssetDetails.MediaContent.ImageContent" src={url} />;
  }
  const Image = vaultImageProxy(
    styled.img`
        ${imageStyle}
      `,
  );
  return <Image id="AssetDetails.MediaContent.ImageContent" src={url} />;
};

const FullSizeImage = (url, photoRotation) => {
  const computedRotation = getRotation(photoRotation);
  if (computedRotation) {
    const Image = vaultImageProxy(
      styled.img`
        ${fullSizeImageStyle}
        ${`transform: rotate(${computedRotation.rotation}deg)`};
      `,
    );
    return <Image id="AssetDetails.MediaContent.ImageContent.FullSize" src={url} />;
  }
  const Image = vaultImageProxy(
    styled.img`
      ${fullSizeImageStyle}
      `,
  );
  return <Image id="AssetDetails.MediaContent.ImageContent.FullSize" src={url} />;
};

class ImageContent extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
    this.state = {
      fullSize: false,
    };
  }

  handleClick() {
    this.setState({ fullSize: true });
  }

  handleClose() {
    this.setState({ fullSize: false });
  }

  render() {
    const { imageUrl, fullSizeImageUrl, photoRotation } = this.props;
    const { fullSize } = this.state;
    return (
      <Container>
        <Dialog maxWidth open={fullSize}>
          <VaultButton
            variant="primaryOnWhite"
            style={{
              position: 'absolute', top: 0, right: 0, zIndex: 1,
            }}
            onClick={this.handleClose}
          >
            <Close />
          </VaultButton>
          <DialogContent style={{ padding: '0px 0px' }}>
            <Box component="span">
              <FSImageWrapper>
                {FullSizeImage(fullSizeImageUrl, photoRotation)}
              </FSImageWrapper>
            </Box>
          </DialogContent>
        </Dialog>
        <ImageWrapper>
          {PreviewImage(imageUrl, photoRotation)}
          <VaultButton
            id="AssetDetails.MediaContent.ImageContent.PreviewButton"
            variant="transparentOnBlack"
            style={{ position: 'absolute', bottom: 5, right: 5 }}
            onClick={this.handleClick}
            data-tip="Image Preview"
            data-for="operations-tooltip"
          >
            <Fullscreen />
          </VaultButton>
        </ImageWrapper>
      </Container>
    );
  }
}

ImageContent.propTypes = {
  imageUrl: PropTypes.string.isRequired, // supplied from MediaContent
  fullSizeImageUrl: PropTypes.string.isRequired, // supplied from MediaContent
  photoRotation: PropTypes.number, // supplied from MediaContent
};

const mapStateToProps = (state) => ({
  rawAssetDetails: state.rawAssetDetails,
});

export default connect(mapStateToProps)(ImageContent);
